<div
  class="body ui container fluid"
  fxLayout="column"
  fxLayoutAlign="flex-start none"
>
<div class="breadcrumb">
  <div class="breadcrumb-itself">
    <div class="left">
      <div>
          <img src="assets/icons/left-arrow-icon.svg" alt=""  (click)="goBack()"/>
        </div>
  </div>
  <div class="right">
      <div class="top">
          <h4>Home / Settings / Rate Limit</h4>
      </div>
      <div class="bottom">
          <h2 class="ui primary header">Rate Limit</h2>
      </div>
  </div>
  </div>
  <div class="far-right" *ngIf="showAddCountryButton">
    <button (click)="addCountry()">Add Country</button>
  </div>
</div>
  <div class="ui divider" appMargin marginY="3"></div>

  <sui-tabset>
    <div class="ui pointing secondary menu" style="margin-top: 20px;">
      <a
        class="item"
        routerLink="/admin/setting/application-security/rate-limit/dashboard"
        routerLinkActive="active"
        >Rate Limit Dashboard</a
      >
      <a
        class="item"
        routerLink="/admin/setting/application-security/rate-limit/logs"
        routerLinkActive="active"
        >Rate Limit Logs</a
      >
      <a
        class="item"
        routerLink="/admin/setting/application-security/rate-limit/profile-setting"
        routerLinkActive="active"
        >Rate Limit Profile Settings</a
      >
      <a
        class="item"
        routerLink="/admin/setting/application-security/rate-limit/global-profile-setting"
        routerLinkActive="active"
        >Global Rate Limit Settings</a
      >

      <a
        class="item"
        routerLink="/admin/setting/application-security/rate-limit/user-profile"
        routerLinkActive="active"
        >Users with Rate Limit Profile</a
      >
      
    </div>
  </sui-tabset>

  <router-outlet></router-outlet>
</div>
